import type { TaxExemptBadge as TaxExemptBadgeFacts } from '@bms2/shared';
import { Icon } from '../Icon';
import styles from './TaxExemptBadge.module.css';

/**
 * 🔒 The gold certificate badge on a site's name line (piece 13, the Sites tile;
 * T3076, decision 7390): the Tax Exempt certificate glyph and its years, `'25–'27`
 * or `'25`, with the state code before them only where the site holds two or
 * more. Hovering it reads the certificate with both dates in the viewer's format.
 * It draws only from the words the shared function made, so a row that carries no
 * certificate never reaches it.
 */
export function TaxExemptBadge({ badge }: { badge: TaxExemptBadgeFacts }) {
  return (
    <span className={styles.badge} title={badge.title} aria-label={badge.title} role="img" data-tile-badge="taxExempt">
      <Icon meaning="taxExemptCertificate" size="inline" />
      <span className={styles.years}>{badge.text}</span>
    </span>
  );
}
